import site from '../../site';

const getCurrentHtmlLocale = (state) => {
  const activePageId = site.selectors.getActivePageId(state);
  const activePage = site.selectors.getPage(state, activePageId);

  if (!activePage) return null;

  return activePage.htmlLocale;
};

export default getCurrentHtmlLocale;
